window.addEventListener('load', function () {
    'use strict';

    if (!document.querySelector('.inv-hero')) return;

    // Hero reveal timeline
    var heroTl = gsap.timeline();

    heroTl.fromTo('.inv-hero .hero__label',
        { y: 20, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out' }
    )
    .fromTo('.inv-hero__title-word',
        { y: 80, opacity: 0 },
        { y: 0, opacity: 1, duration: 1, stagger: 0.12, ease: 'power3.out' },
        '-=0.4'
    )
    .fromTo('.inv-hero__subtitle',
        { y: 20, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out' },
        '-=0.5'
    )
    .fromTo('.inv-hero__content .btn',
        { y: 20, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.6, ease: 'power3.out' },
        '-=0.4'
    )
    .fromTo('.inv-hero__scroll',
        { opacity: 0 },
        { opacity: 1, duration: 0.6 },
        '-=0.3'
    );

    // Hero bg parallax
    var heroBgImg = document.querySelector('.inv-hero__bg img');
    if (heroBgImg) {
        gsap.to(heroBgImg, {
            yPercent: 20,
            ease: 'none',
            scrollTrigger: {
                trigger: '.inv-hero',
                start: 'top top',
                end: 'bottom top',
                scrub: true
            }
        });
    }

    // Philosophy cards stagger
    gsap.utils.toArray('.inv-philosophy__card').forEach(function (card, i) {
        gsap.fromTo(card,
            { y: 50, opacity: 0 },
            {
                y: 0, opacity: 1,
                duration: 0.8,
                delay: i * 0.15,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: card,
                    start: 'top 85%',
                    toggleActions: 'play none none none'
                }
            }
        );
    });

    // Calculator rows stagger
    gsap.utils.toArray('.inv-example__calc-row').forEach(function (row, i) {
        gsap.fromTo(row,
            { x: 30, opacity: 0 },
            {
                x: 0, opacity: 1,
                duration: 0.7,
                delay: i * 0.08,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: row,
                    start: 'top 90%',
                    toggleActions: 'play none none none'
                }
            }
        );
    });

    // Project cards stagger
    gsap.utils.toArray('.inv-projects__card').forEach(function (card, i) {
        gsap.fromTo(card,
            { y: 50, opacity: 0 },
            {
                y: 0, opacity: 1,
                duration: 0.8,
                delay: i * 0.15,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: card,
                    start: 'top 85%',
                    toggleActions: 'play none none none'
                }
            }
        );
    });

    // Founder image reveal
    var founderImg = document.querySelector('.inv-founder__image img');
    if (founderImg) {
        gsap.fromTo(founderImg,
            { scale: 1.15, opacity: 0 },
            {
                scale: 1, opacity: 1,
                duration: 1.4,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: '.inv-founder__image',
                    start: 'top 80%',
                    toggleActions: 'play none none none'
                }
            }
        );
    }
});
